import { func, number, bool } from "prop-types"
import { Button, Spinner } from "@planningcenter/tapestry-react"

const StepActions = ({ currentStep, totalSteps, onSave, onStep, isLoading, nextStepDisabled }) => {
  const isLastStep = totalSteps === currentStep + 1
  const isFirstStep = currentStep === 0

  return (
    <div className="line p-2 d-f jc-sb">
      {isFirstStep && <CancelButton />}
      {!isFirstStep && <BackButton onClick={onStep} currentStep={currentStep} />}
      {isLastStep ? (
        <SaveButton onClick={onSave} disabled={nextStepDisabled} isLoading={isLoading} />
      ) : (
        <NextButton onClick={onStep} currentStep={currentStep} disabled={nextStepDisabled} />
      )}
    </div>
  )
}

StepActions.propTypes = {
  currentStep: number,
  totalSteps: number,
  onSave: func,
  onStep: func,
  isLoading: bool,
  nextStepDisabled: bool
}

const BackButton = ({ onClick, currentStep }) => {
  return (
    <Button
      onClick={() => {
        onClick(currentStep - 1)
      }}
      disabled=""
      title="Back"
    />
  )
}

BackButton.propTypes = {
  onClick: func,
  currentStep: number
}

const NextButton = ({ onClick, currentStep, disabled }) => {
  return (
    <Button
      onClick={() => {
        onClick(currentStep + 1)
      }}
      marginLeft={1}
      theme="create"
      disabled={disabled}
      title="Next"
    />
  )
}

NextButton.propTypes = {
  onClick: func,
  currentStep: number,
  disabled: bool
}

const CancelButton = () => {
  return (
    <Button
      onClick={() => {
        Turbolinks.visit(`/signups/`)
      }}
      title="Cancel"
    />
  )
}

const SaveButton = ({ onClick, disabled, isLoading }) => {
  return (
    <Button
      onClick={onClick}
      theme="create"
      disabled={disabled || isLoading}
      title={!isLoading ? "Save" : null}
    >
      {isLoading && <Spinner size="xs" color="var(--t-fill-color-neutral-100)" />}
    </Button>
  )
}

SaveButton.propTypes = {
  onClick: func,
  disabled: bool,
  isLoading: bool
}

export default StepActions
